export default __webpack_public_path__ + "static/media/24.f1afd951.png";